import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBImportType } from '../../types/import';
import { Field } from '../../types/misc';
import { EndpointResponse } from '../../types/endpoints';
import type { ApiQueryParams } from '../../types/apiQuery';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

const validate = (importType: DBImportType) => {
  if (!importType) {
    throw new Error('`importType` is required');
  }
};

type RequestParams = Pick<ApiQueryParams, 'limit'> & {
  importType: DBImportType;
  all?: boolean;
};

type Response = Field[];

export const getImportTypeFields = async (
  scope: RequestScope,
  { importType, limit = 1000, all = true }: RequestParams,
  requestOptions: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(importType);

    const result = await scopedApi(scope).get<EndpointResponse<Response>>(`${importType}/fields?limit=${limit}&all=${all ? 1 : 0}`, requestOptions);
    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
